export const config = {
  spacetimeDbUri: import.meta.env.VITE_SPACETIMEDB_URI ?? "https://maincloud.spacetimedb.com",
  spacetimeDbModule: import.meta.env.VITE_SPACETIMEDB_MODULE ?? "timerertim-plapok-01",
};